namespace GeniuzPOS.ReportMasterData {
    export interface Report_1502Row {
        Id?: string;
        DocDate?: string;
        DocDateEn?: string;
        Year?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        Qty?: number;
        GrossSales?: number;
        NetSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1502Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1502';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            DocDateEn = "DocDateEn",
            Year = "Year",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            Qty = "Qty",
            GrossSales = "GrossSales",
            NetSales = "NetSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
